import { render, staticRenderFns } from "./deal-edit.vue?vue&type=template&id=48102646&"
import script from "./deal-edit.vue?vue&type=script&lang=js&"
export * from "./deal-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports